<template>
  <v-dialog
      max-width="500px"
      v-model="dialog"
  >
    <template v-slot:activator="{ on }">
      <v-btn
          icon
          color="indigo"
          large
          title="Edit applicant details"
          v-on="on"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-list-item dark class="indigo lighten-1 py-2">
        <v-list-item-avatar>
          <v-icon>mdi-account</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">Edit Applicant</v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn icon @click.stop="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
      <v-card-text class="pt-6">
        <applicant-form ref="form" v-model="applicant"></applicant-form>
      </v-card-text>
      <v-card-actions class="text-right">
        <div class="flex-grow-1"></div>
        <v-btn
            @click.stop="close()"
            text
            large
            color="warning darken-4"
        >Cancel
        </v-btn>
        <v-btn
            @click.stop="save()"
            text
            large
            color="accent darken-4"
        >Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import ApplicantForm from './Form'
import {createApplicant} from '../const'
import {errorNotification} from "@/components/utils";

export default {
  components: {
    ApplicantForm
  },
  name: 'ApplicantEditDialog',
  props: {
    id: Number
  },
  data() {
    return {
      dialog: false,
      applicant: createApplicant()
    }
  },
  watch: {
    dialog: function (dialog) {
      if (dialog) {
        this.fetchData()
      }
    }
  },
  computed: {},
  methods: {
    fetchData() {
      this.$axios.get('/applicants/' + this.id + '/')
          .then((response) => {
            this.applicant = response.data
            this.applicant.passport = null
          })
          .catch((error) => {
            errorNotification(error)
          })
    },
    close() {
      // this.$refs.form.reset()
      this.dialog = false
    },
    save() {
      if (this.$refs.form.validate()) {
        let data = new FormData()
        let applicant = this.applicant
        data.append('application', applicant.application)
        for (var key in applicant) {
          if (!(key == 'passport' && applicant[key] === null)) {
            data.append(key, applicant[key])
          }
        }
        this.$axios.patch('/applicants/' + this.applicant.id + '/', data)
            .then(() => {
              this.$store.dispatch('snackbar/info', 'Applicant details updated')
              this.$emit('success')
              this.close()
            })
            .catch((error) => {
              errorNotification(error)
            })
      }
    }
  },
  mounted() {
    this.fetchData()
  }
}
</script>